import {createFileRoute, Outlet, redirect} from "@tanstack/react-router";

export const Route
    = createFileRoute("/_auth/admin")({
    component: Outlet,
    beforeLoad: (({context}) => {
        if (!!context.myself && !context.myself.canAdmin) {
            throw redirect({to: "/", replace: true});
        }
        return context;
    }),
});
